import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import { Chip, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { IndicatorBar } from '../../../../../components/IndicatorBar'
import { ParameterDetailsActions } from '../../../../../store/parameterDetails'
import { TestParameter } from '../../../../../store/waterTestStrip/types'
import { ParameterDrawer } from '../ParameterDrawer'

interface ParameterResultProps {
  parameter: TestParameter
  color?: string
}

export const ParameterResult = ({ parameter, color }: ParameterResultProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const dispatch = useDispatch()
  const handleClick = () => {
    dispatch(ParameterDetailsActions.setSelectedParameter(parameter))
    setDrawerOpen(true)
  }
  const theme = useTheme()
  const { label, value, measurement, name } = parameter

  const getLabelColor = (label: string) => {
    switch (label) {
      case 'Good':
        return {
          color: theme.palette.success.main,
          backgroundColor: theme.palette.success.light,
        }
      case 'High':
      case 'Low':
        return {
          color: theme.palette.error.main,
          backgroundColor: theme.palette.error.light,
        }
      case 'Caution':
        return {
          color: theme.palette.yellow[800],
          backgroundColor: theme.palette.yellow[200],
        }
      case 'N/A':
      default:
        return {
          color: theme.palette.grey[600],
          backgroundColor: theme.palette.grey[200],
        }
    }
  }

  return (
    <>
      <Stack
        spacing={1}
        direction={'row'}
        alignItems={'center'}
        sx={{
          backgroundColor:
            label === 'High'
              ? theme.palette.red[50]
              : label === 'Caution'
                ? theme.palette.yellow[50]
                : theme.palette.background.default,
          padding: '16px',
          justifyContent: 'space-between',
          borderRadius: '8px',
        }}
      >
        <Stack direction={'row'} gap={2}>
          <IndicatorBar height={50} borderRadius={1} color={color} />
          <Stack>
            <Typography fontSize="1.1rem" color="primary.dark" fontWeight={'bold'}>
              {name}
            </Typography>
            <Typography fontSize="1.1rem" color="primary.dark" fontWeight={'bold'}>
              {name === 'pH' ? value.toFixed(1) : value}{' '}
              <span
                style={{
                  color: theme.palette.grey[600],
                  fontWeight: 'medium',
                }}
              >
                {measurement}
              </span>
            </Typography>
          </Stack>
        </Stack>

        <Stack spacing={1} alignItems={'end'}>
          <Chip
            label={
              <Stack direction="row" spacing={1} alignItems="center">
                <div
                  style={{
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    backgroundColor: 'currentColor',
                    marginRight: '4px',
                  }}
                />
                {label}
              </Stack>
            }
            sx={getLabelColor(label)}
            size="small"
          />
          <Stack
            onClick={handleClick}
            direction={'row'}
            gap={0.3}
            alignItems={'center'}
            sx={{ cursor: 'pointer' }}
          >
            <Typography color="info.main" fontSize={'14px'} fontWeight={'medium'}>
              Learn more
            </Typography>
            <ArrowForwardIosOutlinedIcon
              sx={{ color: theme.palette.info.main, fontSize: '12px' }}
            />
          </Stack>
        </Stack>
      </Stack>
      <ParameterDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  )
}
